import z from "zod";

/**
 * The files an offer import is raised from. Capped, because the importer reads every one of them
 * and a GAEB pair or a two-part Angebot is the realistic upper end — a selection of forty
 * documents is a mis-click rather than one offer.
 */
export const postCalculationFromFilesSchema = z.object({
	fileIds: z.array(z.string()).min(1).max(10),
});

export type PostCalculationFromFilesSchema = z.infer<typeof postCalculationFromFilesSchema>;
